module.exports = __webpack_public_path__ + "img/vendor_logo4.612f812e.png";